import _get from 'lodash/get';
/**
 * This function states whether the user has access to surveys elements or not.
 * @param {object} session - Details about user's available features based on their session.
 * @returns {boolean} allSurveysAreEnabled - Whether the user can use surveys in their emails.
 */
export default function (session) {
    const userFeatures = _get(session, 'user.features', {});
    const socialReactionsEnabled = userFeatures.SURVEY_SOCIAL_REACTIONS === true;
    const pulseSurveysEnabled = userFeatures.SURVEYS_PULSE_CUSTOM === true;
    const eNpsSurveyEnabled = userFeatures.SURVEY_ENPS === true;
    const allSurveysAreEnabled = socialReactionsEnabled && pulseSurveysEnabled && eNpsSurveyEnabled;
    return allSurveysAreEnabled;
}
